import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { push } from "connected-react-router";
import { Header } from "@digix-ui/componentes";
import { ReactComponent as logoHabix } from "../Logos/logo-habix.svg";
import MenuDeTrocaDeModulos from "../Header/componentes/MenuDeTrocaDeModulos";
import { limparLocalDeAtendimento } from "../../actions/informacoesDeLocalDeAtendimento.actions";
import { efetuarLogOut } from "../../actions/login.actions";
import "./styles.scss";
import MenuLateral from "./components/MenuLateral";

const urlPoliticaDePrivacidade = process.env.REACT_APP_URL_POLITICA_DE_PRIVACIDADE;
const urlTermoDeUso = process.env.REACT_APP_URL_TERMO_DE_USO;
const urlSuporte = process.env.REACT_APP_URL_SUPORTE;
const urlSeguranca = process.env.REACT_APP_URL_SEGURANCA;

const urlDeAlteracaoDeSenha = `${urlSeguranca}/Seguranca/AlterarSenha`;

function obterLoginDoUsuario(usuarioLogado) {
  return usuarioLogado && Object.keys(usuarioLogado).length > 0
    ? usuarioLogado.login.toLowerCase()
    : "";
}

const informacoesDeLocalDeAtendimentoUsuario = (localAtendimentoRedux) => {
  if (Object.keys(localAtendimentoRedux.localDeAtendimento).length === 0) {
    const local = localStorage.getItem("localDeAtendimento");
    const podeAlterar = localStorage.getItem("podeAlterarLocalDeAtendimento");
    if (local != null) {
      localAtendimentoRedux.localDeAtendimento = JSON.parse(local);
      localAtendimentoRedux.podeAlterarLocalDeAtendimento =
        podeAlterar === "true";
    }
  }
  return localAtendimentoRedux;
};

const CabecalhoAdministrativo = (props) => {
  const [menuExpandido, setMenuExpandido] = useState(false);

  const dispatch = useDispatch();
  const localAtendimentoRedux = useSelector(
    (state) => state.informacoesDeLocalDeAtendimento
  );
  const usuarioLogado = useSelector((state) => state.usuario);

  const infoLocal = informacoesDeLocalDeAtendimentoUsuario(
    localAtendimentoRedux
  );
  const localDeAtendimento = infoLocal.localDeAtendimento;
  const podeAlterarLocal = infoLocal.podeAlterarLocalDeAtendimento;
  const possuiLocal =
    localDeAtendimento && Object.keys(localDeAtendimento).length > 0;
  const login = obterLoginDoUsuario(usuarioLogado);

  useEffect(() => {
    const botao = document.querySelector(".botao-hamburguer");
    const toggleMenu = () => setMenuExpandido((prev) => !prev);

    if (botao) {
      botao.addEventListener("click", toggleMenu);
    }

    return () => {
      if (botao) {
        botao.removeEventListener("click", toggleMenu);
      }
    };
  }, []);

  const sairDoSistema = (e) => {
    e.preventDefault();
    dispatch(efetuarLogOut());
  };

  const alterarLocal = (e) => {
    e.preventDefault();
    if (!podeAlterarLocal) return;
    dispatch(limparLocalDeAtendimento());
    localStorage.removeItem("localDeAtendimento");
    dispatch(push("locais-de-atendimento"));
  };

  const botoesDeAcoesDoUsuario = [
    <a
      key="alterarSenha"
      href={urlDeAlteracaoDeSenha}
      className="dropdown__link"
    >
      <i className="fal fa-exchange dropdown__icone"></i> Alterar Senha
    </a>,
    <a
      key="termoDeUso"
      href={urlTermoDeUso}
      target="_blank"
      rel="noreferrer"
      className="dropdown__link"
    >
      <i className="fal fa-file-check dropdown__icone"></i> Termo de Uso
    </a>,
    <a
      key="politica"
      href={urlPoliticaDePrivacidade}
      target="_blank"
      rel="noreferrer"
      className="dropdown__link"
    >
      <i className="fal fa-lock dropdown__icone"></i> Política de Privacidade
    </a>,
    <a
      key="sair"
      href="#sair"
      onClick={sairDoSistema}
      className="dropdown__link"
    >
      <i className="far fa-sign-out dropdown__icone"></i> Sair
    </a>,
  ];

  const itensPrimarios = <MenuDeTrocaDeModulos />;
  const itensSecundarios = [
    <li key="suporte" className="dropdown dropdown_direita">
      <a className="cabecalho-sistema__item-de-menu" href={urlSuporte} target="_blank" rel="noreferrer">
        Suporte <i className="far fa-angle-down u-margem-esquerda-pequena"></i>
      </a>
    </li>,
    possuiLocal && (
      <li key={localDeAtendimento.id}>
        <a
          className="cabecalho-sistema__item-de-menu"
          href="#"
          onClick={alterarLocal}
        >
          {localDeAtendimento.descricao} - {localDeAtendimento.cidadeComUf}
          {podeAlterarLocal && (
            <i className="far fa-exchange u-margem-esquerda-pequena"></i>
          )}
        </a>
      </li>
    ),
  ];

  return (
    <div className={`tema-habix ${menuExpandido ? "com-menu-visivel" : ""}`}>
      <Header
        component={logoHabix}
        nomeDoUsuario={login}
        comMenuLateral={true}
        botoesDeAcoesDoUsuario={botoesDeAcoesDoUsuario}
        itensPrimarios={itensPrimarios}
        itensSecundarios={itensSecundarios}
      />

      <MenuLateral expandido={menuExpandido} setExpandido={setMenuExpandido} />

      <div className="conteudo">{props.children}</div>
    </div>
  );
};

export default CabecalhoAdministrativo;
